/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SnapshotItemResponse } from '../models/SnapshotItemResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SnapshotService {
    /**
     * List Snapshots
     * 조회 가능한(`status=ready`) 시점 스냅샷 목록을 최신순으로 반환.
     *
     * 프론트는 응답의 `as_of` 값을 기존 API 호출에 `?as_of=2026-W25` 로 전달해 그 시점으로 조회한다.
     * `period` 로 weekly|monthly 필터 가능.
     * @returns SnapshotItemResponse OK
     * @throws ApiError
     */
    public static appsSnapshotViewsListSnapshots({
        period,
    }: {
        period?: string,
    }): CancelablePromise<Array<SnapshotItemResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/snapshots',
            query: {
                'period': period,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
